import { motion } from "framer-motion";

const MaskedUnit = ({ children, d, immediate = false }) => (
  <motion.span
    className="inline-block overflow-hidden pb-[0.1em] -mb-[0.1em] align-bottom"
    initial="hidden"
    {...(immediate
      ? { animate: "visible" }
      : { whileInView: "visible", viewport: { once: true, margin: "-50px" } })}
  >
    <motion.span
      className="inline-block will-change-transform"
      variants={{ hidden: { y: "115%" }, visible: { y: "0%" } }}
      transition={{ duration: 0.65, delay: d, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </motion.span>
);

export const AnimatedText = ({ text, delay = 0, stagger = 0.04, className = "", byLetter = false, immediate = false }) => {
  const lines = Array.isArray(text) ? text : [text];
  let wi = 0;

  return (
    <span className={className}>
      {lines.map((line, li) => (
        <span key={li} className="block">
          {line.split(" ").map((word, i) => {
            if (byLetter) {
              return (
                <span key={`${li}-${i}`} className="inline-block whitespace-nowrap">
                  {word.split("").map((ch, ci) => {
                    const d = delay + wi++ * stagger;
                    return <MaskedUnit key={ci} d={d} immediate={immediate}>{ch}</MaskedUnit>;
                  })}
                  {i < line.split(" ").length - 1 ? "\u00A0" : ""}
                </span>
              );
            }
            const d = delay + wi++ * stagger;
            return (
              <MaskedUnit key={`${li}-${i}`} d={d} immediate={immediate}>
                {word}
                {i < line.split(" ").length - 1 ? "\u00A0" : ""}
              </MaskedUnit>
            );
          })}
        </span>
      ))}
    </span>
  );
};
